import { AiAgentsSetting } from '@/features/ai_agents_setting';

const AiAgentSettingPage = () => {
  return <AiAgentsSetting />;
};
export default AiAgentSettingPage;
